import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sx" }
const _hoisted_2 = { class: "sx-grid" }
const _hoisted_3 = { class: "sx-field" }
const _hoisted_4 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_7 = {
  class: "sx-card",
  "aria-labelledby": "tc-list-title"
}
const _hoisted_8 = { class: "sx-list-head" }
const _hoisted_9 = { id: "tc-list-title" }
const _hoisted_10 = { class: "sx-count" }
const _hoisted_11 = { class: "sx-search" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "sx-load-error",
  role: "alert"
}
const _hoisted_14 = {
  key: 2,
  class: "sx-empty"
}
const _hoisted_15 = {
  key: 3,
  class: "sx-rows"
}
const _hoisted_16 = {
  class: "sx-avatar",
  "aria-hidden": "true"
}
const _hoisted_17 = { class: "sx-main" }
const _hoisted_18 = { class: "sx-meta" }
const _hoisted_19 = { class: "sx-actions" }
const _hoisted_20 = ["aria-label", "onClick"]
const _hoisted_21 = ["aria-label", "title", "disabled", "onClick"]
const _hoisted_22 = {
  id: "editTypeClientModal",
  ref: "editModal",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "editTypeClientModalLabel",
  "aria-hidden": "true"
}
const _hoisted_23 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_24 = { class: "modal-body" }
const _hoisted_25 = { class: "sx-field" }
const _hoisted_26 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_27 = {
  key: 1,
  class: "sx-help"
}
const _hoisted_28 = { class: "modal-footer" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[23] || (_cache[23] = _createElementVNode("header", { class: "sx-head" }, [
      _createElementVNode("span", { class: "sx-eyebrow" }, "Paramètres"),
      _createElementVNode("h1", { class: "sx-title" }, "Types client"),
      _createElementVNode("p", { class: "sx-sub" }, "Catégories attribuées aux clients (société, auto-entrepreneur, particulier…) dans leur fiche.")
    ], -1)),
    _createVNode(_component_SettingsNav),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "sx-card sx-form-card",
        novalidate: "",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _cache[9] || (_cache[9] = _createElementVNode("header", { class: "sx-card-head" }, [
          _createElementVNode("span", { class: "sx-card-icon" }, [
            _createElementVNode("i", {
              class: "ph ph-users-three",
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h2", null, "Nouveau type client"),
            _createElementVNode("p", null, "Il sera proposé dans la fiche client.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("label", { for: "tc-new-name" }, [
            _createTextVNode("Nom du type "),
            _createElementVNode("span", {
              class: "sx-req",
              "aria-hidden": "true"
            }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            id: "tc-new-name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type.name) = $event)),
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.name }]),
            maxlength: "100",
            placeholder: "Ex. Société",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (delete _ctx.errors.name))
          }, null, 34), [
            [_vModelText, _ctx.type.name]
          ]),
          (_ctx.errors.name)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.errors.name), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary sx-submit",
          disabled: _ctx.saving
        }, [
          (_ctx.saving)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6))
            : _createCommentVNode("", true),
          _cache[8] || (_cache[8] = _createTextVNode(" Ajouter le type ", -1))
        ], 8, _hoisted_5)
      ], 32),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h2", _hoisted_9, [
            _cache[10] || (_cache[10] = _createTextVNode("Types client ", -1)),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.types.length), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[11] || (_cache[11] = _createElementVNode("i", {
              class: "ph ph-magnifying-glass",
              "aria-hidden": "true"
            }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
              type: "search",
              placeholder: "Rechercher un type…",
              "aria-label": "Rechercher un type client"
            }, null, 512), [
              [_vModelText, _ctx.search]
            ])
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                return _createElementVNode("span", {
                  key: n,
                  class: "sx-skel"
                })
              }), 64))
            ]))
          : (_ctx.loadError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _cache[12] || (_cache[12] = _createElementVNode("i", {
                  class: "ph ph-warning-circle",
                  "aria-hidden": "true"
                }, null, -1)),
                _cache[13] || (_cache[13] = _createTextVNode(" Impossible de charger les types client. ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-light",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fetchTypes && _ctx.fetchTypes(...args)))
                }, "Réessayer")
              ]))
            : (!_ctx.filtered.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[14] || (_cache[14] = _createElementVNode("i", {
                    class: "ph ph-users-three",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.search ? "Aucun type ne correspond à votre recherche." : "Aucun type client pour le moment."), 1)
                ]))
              : (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.id,
                      class: _normalizeClass(["sx-row", { 'is-new': item.id === _ctx.lastAddedId }])
                    }, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.initials(item.name)), 1),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                        _createElementVNode("small", null, _toDisplayString(_ctx.num(item.NbClient) > 0 ? "Utilisé" : "Non utilisé"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["sx-tag", { 'tone-accent': _ctx.num(item.NbClient) > 0 }])
                        }, [
                          _cache[15] || (_cache[15] = _createElementVNode("i", {
                            class: "ph ph-storefront",
                            "aria-hidden": "true"
                          }, null, -1)),
                          _createElementVNode("b", null, _toDisplayString(_ctx.num(item.NbClient)), 1),
                          _cache[16] || (_cache[16] = _createTextVNode(" client(s) ", -1))
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "sx-icon-btn",
                          "aria-label": `Modifier ${item.name}`,
                          title: "Modifier",
                          onClick: ($event: any) => (_ctx.openEditModal(item.id))
                        }, _cache[17] || (_cache[17] = [
                          _createElementVNode("i", {
                            class: "ph ph-pencil-simple",
                            "aria-hidden": "true"
                          }, null, -1)
                        ]), 8, _hoisted_20),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sx-icon-btn is-danger",
                          "aria-label": `Supprimer ${item.name}`,
                          title: _ctx.num(item.NbClient) > 0 ? 'Impossible : type attribué à des clients' : 'Supprimer',
                          disabled: _ctx.num(item.NbClient) > 0,
                          onClick: ($event: any) => (_ctx.deleteType(item.id))
                        }, _cache[18] || (_cache[18] = [
                          _createElementVNode("i", {
                            class: "ph ph-trash",
                            "aria-hidden": "true"
                          }, null, -1)
                        ]), 8, _hoisted_21)
                      ])
                    ], 2))
                  }), 128))
                ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("form", {
          class: "modal-content",
          novalidate: "",
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateType && _ctx.updateType(...args)), ["prevent"]))
        }, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h2", {
              id: "editTypeClientModalLabel",
              class: "modal-title"
            }, "Modifier le type client"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { for: "tc-edit-name" }, [
                _createTextVNode("Nom du type "),
                _createElementVNode("span", {
                  class: "sx-req",
                  "aria-hidden": "true"
                }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "tc-edit-name",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editType.name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.editErrors.name }]),
                maxlength: "100"
              }, null, 2), [
                [_vModelText, _ctx.editType.name]
              ]),
              (_ctx.editErrors.name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.editErrors.name), 1))
                : (_ctx.editUsage > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Le nouveau nom s'appliquera aux " + _toDisplayString(_ctx.editUsage) + " client(s) de ce type.", 1))
                  : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[21] || (_cache[21] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              "data-bs-dismiss": "modal"
            }, "Annuler", -1)),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary",
              disabled: _ctx.savingEdit
            }, [
              (_ctx.savingEdit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                : _createCommentVNode("", true),
              _cache[20] || (_cache[20] = _createTextVNode(" Enregistrer ", -1))
            ], 8, _hoisted_29)
          ])
        ], 32)
      ])
    ], 512)
  ]))
}